var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc-erm"},[_c('ops-desk-settings',{ref:"body",attrs:{"page":"","initial-tab":_vm.initialTab},on:{"dirty":_vm.onDirty,"rail":function($event){return _vm.$emit('rail', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }